import { PropsWithChildren, ReactNode } from "react";

import { css } from "@compiled/react";

const expanderStackCss = css({
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "24px",
    width: "100%"
});

const expanderStackHeadingCss = css({
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 600,
    margin: 0,
    color: "var(--wac-color-heading)"
});

export interface ExpanderStackProps extends PropsWithChildren {
    heading?: ReactNode;
    lozenge?: ReactNode;
}

export const ExpanderStack = (props: ExpanderStackProps) => {
    return (
        <div css={expanderStackCss}>
            {props.lozenge}
            {props.heading && (
                <h3 css={expanderStackHeadingCss}>{props.heading}</h3>
            )}
            {props.children}
        </div>
    );
};
